const config = {};

if (process.env.NODE_ENV === 'dev') {
  Object.assign(config, {
    // BASE_API: 'http://47.97.157.21:8088',
    BASE_API: 'http://47.99.37.209:8088',
  });
} else if (process.env.NODE_ENV === 'fat') {
  Object.assign(config, {
    BASE_API: 'http://47.99.37.209:8088',
  });
} else if (process.env.NODE_ENV === 'uat') {
  Object.assign(config, {
    BASE_API: 'http://47.99.34.250:8088',
  });
} else if (process.env.NODE_ENV === 'pro') {
  Object.assign(config, {
    BASE_API: 'https://govapi.hellobike.com',
  });
}

export default config;



// WEBPACK FOOTER //
// ./src/api/config.js